import { jsx } from "react/jsx-runtime";
import React from "react";
import { ReactTableDefaults } from "@teselagen/react-table";
const { LoadingComponent } = ReactTableDefaults;
function DisabledLoadingComponent({ disabled, loading, loadingText }) {
  return /* @__PURE__ */ jsx(
    LoadingComponent,
    {
      className: disabled ? "disabled" : "",
      loading,
      loadingText: disabled ? "" : loadingText
    }
  );
}
export default DisabledLoadingComponent;
